import {Button} from '@material-ui/core';
import {GetApp} from '@material-ui/icons';
import * as XLSX from 'xlsx';

const { format: formatDate } = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', });

const onlineStatusLabels = {
  finished: 'CONCLUÍDO',
  started: 'FINALIZADA AUTOMATICAMENTE',
};

const printedStatusLabels = {
  finished: 'CONCLUÍDO',
};

const calcPercentage = (value, total) => {
  return (value * 100 / total).toFixed(1)
}

const buildFileName = (availabilityName) => {
  const name = (availabilityName || 'avaliacao')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase();
  return `resultados_${name}.xlsx`;
}

const exportResults = (studentResults, assessmentType, availabilityName) => {
  const isPrinted = assessmentType === 'printed';

  const exportData = studentResults.map((student) => {
    const status = isPrinted
      ? printedStatusLabels[student.status] || 'AGUARDANDO RESULTADOS'
      : onlineStatusLabels[student.status] || 'NÃO INICIADO';
    const hasResult = student.correctAnswers !== null && student.correctAnswers !== undefined;

    return {
      'Aluno': student.studentName,
      'Status': status,
      ...(!isPrinted && {
        'Início da Avaliação': student.startedAt ? formatDate(new Date(student.startedAt)) : '-',
        'Término da Avaliação': student.finishedAt ? formatDate(new Date(student.finishedAt)) : '-',
      }),
      'Acertos': hasResult ? student.correctAnswers : '-',
      'Total de Questões': student.totalQuestions ?? '-',
      '% Acertos': hasResult ? calcPercentage(student.correctAnswers, student.totalQuestions) + '%' : '-',
    };
  });

  const ws = XLSX.utils.json_to_sheet(exportData);
  ws['!cols'] = [
    { wch: 35 },
    { wch: 28 },
    ...(!isPrinted ? [{ wch: 20 }, { wch: 20 }] : []),
    { wch: 12 },
    { wch: 18 },
    { wch: 12 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Resultados');
  XLSX.writeFile(wb, buildFileName(availabilityName));
}

export function ExportResultsAction({ studentResults, assessmentType, availabilityName, disabled }) {
  return (
    <Button
      variant={'outlined'}
      color={'default'}
      size={'small'}
      startIcon={<GetApp />}
      onClick={() => exportResults(studentResults, assessmentType, availabilityName)}
      disabled={disabled || !studentResults?.length}
      style={{ marginRight: 10 }}
    >
      Exportar Resultados
    </Button>
  );
}
